// @flow

import styles from './HelpLink.less';

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { HelpIcon } from 'seek-style-guide/react';

import NavLink from 'src/components/NavLink/NavLink';

import { searchHelpClicked } from 'src/store/search/search';

const mapDispatchToProps = dispatch => ({
  onHelpClick: () => dispatch(searchHelpClicked())
});

type Props = {
  className?: string,
  onHelpClick: Function
};
class HelpLink extends PureComponent<Props> {
  props: Props;

  render() {
    const { className, onHelpClick } = this.props;

    return (
      <NavLink
        analytics="search+help"
        className={classnames(styles.helpLink, className)}
        target="_blank"
        rel="nofollow noopener noreferrer"
        location="/help/"
        title="Help"
        preNavigationHooks={[onHelpClick]}
      >
        <HelpIcon headline />
      </NavLink>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(HelpLink);
